var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--text field-wrapper--large",
      class: [
        _vm.field.cssClass,
        { "visually-hidden": _vm.field.visibility === "hidden" }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "field-group field-group--block",
          class: [
            { "field-group--is-error": _vm.isError },
            { "field-group--block-animated": _vm.time }
          ]
        },
        [
          _c(
            "label",
            {
              staticClass: "label",
              class: [
                {
                  "visually-hidden": _vm.field.labelPlacement === "hidden_label"
                }
              ],
              attrs: { for: "input_" + _vm.field.id }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.field.label)),
              _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("flat-pickr", {
            ref: "flatpickr",
            staticClass: "input-date",
            attrs: {
              id: "input_" + _vm.field.id,
              name: "input_" + _vm.field.id,
              config: _vm.timePicker,
              required: _vm.field.isRequired,
              placeholder: ""
            },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("description"),
      _vm._v(" "),
      _vm._t("error")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }